const config={
    // localhost_url:"http://192.168.0.192:8089",
    // localhost_url:"http://18.61.135.100:8089", //test hyd new
    localhost_url:"https://load.goslash.com", //prod
}
export let apiKeys={}
if(config.localhost_url==='https://load.goslash.com')
{
    apiKeys={
        environment:"production",
        googleApiKey:'AIzaSyCHvGHPNkUvWRF_5mitUotvx1T4M6lvE-s',
    }
}
else
{
    apiKeys={
        environment:"local_dev_test",
        googleApiKey:'AIzaSyDXefZ2cW6MzIngBce6pacVO1YDpBD8eoQ',
    }
}
export default config;